<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌, 사이버보안 교육 과정 신규 런칭…’보안전문가’ 양성</h4>
                            <!-- <div class="board_meta">
                                <ul>
                                    <li>등록일 : 22.05.24</li>
                                    <li>조회수 : 142</li>
                                </ul>
                            </div> -->
                        </div>
                      <div class="board_body">
                            <div class="board_content">
                                <figure class="image"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img_report_08.jpg"></figure>
                                <br>
                                <br>
                                종합교육기업 에듀윌이 오는 6월, 사이버보안 아카데미 교육-화이트 해커 양성 과정을 신규 런칭한다고 밝혔다.
                                <br>
                                <br>
                                차별화된 보안전문인력 양성을 목표로 하는 이번 교육 과정은 정보보안 학과 진학을 준비하는 고등학생부터 정보보안학과에 재학중인 대학생, 보안 업계에 종사하는
                                직장인 등을 대상으로 하는 종합교육과정이다.
                                <br>
                                <br>
                                에듀윌 사이버보안 아카데미 ‘화이트 해커 양성 과정’은 오프라인 교육 과정을 6월 11일(토), 온라인 교육 과정을 8월 중 런칭할 예정이다.
                                <br>
                                <br>
                                6월 11일(토)부터 만나볼 수 있는 오프라인 교육 과정은 수강생 개개인 상황에 꼭 맞는 실습 중심 교육을 운영한다. 실무경험을 갖춘 화이트 해커 출신으로,
                                현직 사이버 보안 전문가인 김주영(현 블랙펄시큐리티 선임 연구원), 임채윤(현 시큐리티 허브 수석 연구원), 신재원(현 블랙펄시큐리티 선임연구원), 최창진(현
                                사이버 보안 스타트업, Co-Founder) 강사가 합류해 업계 최고 수준의 전문가 강사진 라인업을 완성했다. 해당 강사진은 수강생 개개인별 맞춤 교육을
                                진행해, 대학교 진학부터 관련업계 취업 등까지 적극 지원할 예정이다.
                                <br>
                                <br>
                                에듀윌 사이버보안 온라인 교육 과정은 사이버보안 전 분야에 대한 학습을 진행할 수 있도록 300여편의 학습 영상을 제공한다. 특히 학습 과정의 90%를 실습
                                과정으로 구성해 수강생들에게 실제 현장에서 학습하는 것 같은 현장감을 제공한다.
                                <br>
                                <br>
                                에듀윌 관계자는 “사이버보안의 기초부터 현업에 적용할 수 있는 실무 스킬 등까지 배울 수 있는 종합교육과정으로 보안 관련 학과 대학 진학부터, 관련 업체 취직
                                등에 도움이 되는 과정”이라며 “올해 하반기부터는 자체 사이버 보안 전문가 자격증을 발행해 검증 시스템도 운영할 계획”이라고 말했다.
                                <br>
                                <br>
                                한편 종합교육기업 에듀윌은 사이버보안 교육 사업을 시작으로 하반기 개발(코딩) 관련 교육 서비스 런칭을 계획하는 등 본격적인 IT교육 시장 진출을 예고했다.



                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news7" data-value="315283">
                                        <strong>이전</strong>
                                        <span>'베스트셀러 1위’ 휩쓴 에듀윌 토익 교재, 수험생도 에듀윌에 눈떴다!</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                                <!-- 다음 보도 기사가 있을 경우 -->
                                <li class="next">
                                    <router-link to="/edu/newsRelease/promotionVideo/news9" data-value="315283">
                                        <strong>다음</strong>
                                        <span>에듀윌, 국립공주대와 `부동산학과 재학생 교육 지원` 업무 협약
                                            체결</span>
                                    </router-link>
                                </li>
                                <!-- //다음 보도 기사가 있을 경우 -->
                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
